import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { LGButtonsWrapper } from "../styles";
import { SwitcherButtons } from "./SwitcherButtons";
import useContextButtons from "../hooks/useContextButtons";
import { ActionTypes } from "shared/pages/teams/const/ActionTypes";
import { useIsMobile } from "@brg/ui";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";
import { setTeamLongread } from "shared/reducers/ViewTypeSlice";
import { useDispatch } from "react-redux";

const LongreadButtons = ({ team, disciplines, currentTab }) => {
    const dispatch = useDispatch();

    const isMobile = useIsMobile()
    const history = useHistory();
    const { contextName: context, teamId, isLongreadDisabled } = team;

    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isDvaDesign = AppTester.isDvaDesign();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
    const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;
    const teamHasLongread = (!!team?.longread || team?.longreadEntityLink !== '') && !isLongreadDisabled;
    const hasForcedLanding = teamHasLongread;
    const isLMSTeam = team?.moderationType === ModerationType.LMS;

    const { contextButtons, hideSwitcherButtons } = useContextButtons(team, currentTab);

    const setVisibleLG = (value: boolean) => {
        dispatch(setTeamLongread(value))
      }

    const [teamPageLink, brndLink] = useMemo(() => {
        const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
        return [`${basePath}`, `${basePath}/brnd`];
    }, [isLMSTeam, isMainPageTeam, context, teamId])

    
    return (<LGButtonsWrapper isLMSTeam={isLMSTeam}>
        {contextButtons?.filter((button: any) => button?.actionType !== ActionTypes.showcase)?.map(({
            type,
            text: textRaw,
            textMobile,
            href,
            isRequired,
            anchor,
            actionType,
            hidden
        }: any) => {
            const text = isMobile ? textMobile : textRaw;
            const currentUtmParams = new URLSearchParams(window.location.search);


            const link = type?.includes('anchor')
                ? `#${anchor?.value}`
                : href.includes('form')
                    ? `${href}${currentUtmParams.toString() ? `?${currentUtmParams.toString()}` : ''}`
                    : href;

            const isButtonHidden = hidden;

            if (isButtonHidden || !text?.length) return false;

            if (actionType === ActionTypes.longread) {
                return (
                    <SwitcherButtons hide={hideSwitcherButtons} type={type} text={text} action={() => {
                        if (hasForcedLanding) {
                            history.push(team.isShowGridFirst ? teamPageLink : brndLink);
                        }
                        setVisibleLG(false)
                        window.scrollTo(0, 0)
                    }} />
                )
            }
            ;

            if (type === 'filled' || type === 'anchor-filled') {
                return (
                    <a href={link} target={type?.includes('anchor') ? '_self' : "_blank"} rel="noreferrer">
                        <ExploreButtonFilled
                            className={'filled-button'}
                            // importantStyles={!isHSEDesign && !BookDesign}
                            fixedSize
                            isGreenBG={isAgeytomesh}
                        >
                            {text}
                        </ExploreButtonFilled>
                    </a>
                )
            }
            return (
                <a href={link}>
                    <ExploreButtonHollow className='hollow-button' fixedSize>
                        {text}
                    </ExploreButtonHollow>
                </a>
            )
        })}
    </LGButtonsWrapper>)
}

export default LongreadButtons;import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { LGButtonsWrapper } from "../styles";
import { SwitcherButtons } from "./SwitcherButtons";
import useContextButtons from "../hooks/useContextButtons";
import { ActionTypes } from "shared/pages/teams/const/ActionTypes";
import { useIsMobile } from "@brg/ui";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";
import { setTeamLongread } from "shared/reducers/ViewTypeSlice";
import { useDispatch } from "react-redux";

const LongreadButtons = ({ team, disciplines, currentTab }) => {
    const dispatch = useDispatch();

    const isMobile = useIsMobile()
    const history = useHistory();
    const { contextName: context, teamId, isLongreadDisabled } = team;

    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isDvaDesign = AppTester.isDvaDesign();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
    const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;
    const teamHasLongread = (!!team?.longread || team?.longreadEntityLink !== '') && !isLongreadDisabled;
    const hasForcedLanding = teamHasLongread;
    const isLMSTeam = team?.moderationType === ModerationType.LMS;

    const { contextButtons, hideSwitcherButtons } = useContextButtons(team, currentTab);

    const setVisibleLG = (value: boolean) => {
        dispatch(setTeamLongread(value))
      }

    const [teamPageLink, brndLink] = useMemo(() => {
        const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
        return [`${basePath}`, `${basePath}/brnd`];
    }, [isLMSTeam, isMainPageTeam, context, teamId])

    
    return (<LGButtonsWrapper isLMSTeam={isLMSTeam}>
        {contextButtons?.filter((button: any) => button?.actionType !== ActionTypes.showcase)?.map(({
            type,
            text: textRaw,
            textMobile,
            href,
            isRequired,
            anchor,
            actionType,
            hidden
        }: any) => {
            const text = isMobile ? textMobile : textRaw;
            const currentUtmParams = new URLSearchParams(window.location.search);


            const link = type?.includes('anchor')
                ? `#${anchor?.value}`
                : href.includes('form')
                    ? `${href}${currentUtmParams.toString() ? `?${currentUtmParams.toString()}` : ''}`
                    : href;

            const isButtonHidden = hidden;

            if (isButtonHidden || !text?.length) return false;

            if (actionType === ActionTypes.longread) {
                return (
                    <SwitcherButtons hide={hideSwitcherButtons} type={type} text={text} action={() => {
                        if (hasForcedLanding) {
                            history.push(team.isShowGridFirst ? teamPageLink : brndLink);
                        }
                        setVisibleLG(false)
                        window.scrollTo(0, 0)
                    }} />
                )
            }
            ;

            if (type === 'filled' || type === 'anchor-filled') {
                return (
                    <a href={link} target={type?.includes('anchor') ? '_self' : "_blank"} rel="noreferrer">
                        <ExploreButtonFilled
                            className={'filled-button'}
                            // importantStyles={!isHSEDesign && !BookDesign}
                            fixedSize
                            isGreenBG={isAgeytomesh}
                        >
                            {text}
                        </ExploreButtonFilled>
                    </a>
                )
            }
            return (
                <a href={link}>
                    <ExploreButtonHollow className='hollow-button' fixedSize>
                        {text}
                    </ExploreButtonHollow>
                </a>
            )
        })}
    </LGButtonsWrapper>)
}

export default LongreadButtons;